var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef, AfterViewInit } from '@angular/core';
import { CommonTableService } from 'app/services/common-table.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AppSettings } from 'app/app.settings';
import { AdminService } from 'app/services/admin.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/services/auth.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { AddUserModalComponent } from './add-user-modal/add-user-modal.component';
import { ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { IntegratorSelectComponent } from 'app/components/modal/integrator-select/integrator-select.component';
import { PaneControlService } from 'app/services/pane-control.service';
var ConfigUsersComponent = /** @class */ (function () {
    function ConfigUsersComponent(toastr, adminService, appinfoService, authService, commonService, tableService, modalService, paneService, userService) {
        this.toastr = toastr;
        this.adminService = adminService;
        this.appinfoService = appinfoService;
        this.authService = authService;
        this.commonService = commonService;
        this.tableService = tableService;
        this.modalService = modalService;
        this.paneService = paneService;
        this.userService = userService;
        // rows without filter
        this.unfilteredRows = [];
        //
        this.rows = [];
        this.columns = [];
        this.selectedRows = [];
        this.searchStr = '';
        // newUser object is created as the new-user-email's ngModel binding. Not using row[userEmailCol] because:
        // The input in ngx-datatable will lose focus on typing somehow...
        this.newUser = {
            email: ''
        };
        // The name of the property to check new user
        this.isNewUserCol = 'isNewUser';
        //
        this.userEmailCol = 'userEmail';
        this.roleCol = 'userRole';
        this.originalRoleCol = 'originalRole';
        this.operationsCol = 'operations';
        this.usbIdCol = 'usbId';
    }
    ConfigUsersComponent.prototype.onSelectRow = function () { };
    ConfigUsersComponent.prototype.onChangeNewUserEmail = function () {
        console.log('hhhhhh');
    };
    ConfigUsersComponent.prototype.onChangeRole = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var role, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!row[this.isNewUserCol]) return [3 /*break*/, 4];
                        role = this.appinfoService.rolesByApp[AppSettings.appName].find(function (r) { return r.desc === row[_this.roleCol]; });
                        if (!role) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.adminService.updateUserSubscription(row.usbId, role.rol_id)];
                    case 2:
                        _a.sent();
                        this.toastr.success('Successfully updated.');
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.toastr.error('Failed to update user role.');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ConfigUsersComponent.prototype.addUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, result, userId, rsp, err_2, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            width: '550px',
                            height: '250px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(AddUserModalComponent, options)];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 15];
                        if (result.roleDesc === 'INTEGRATOR' && !this.userService.getUserInfo().isAdmin) {
                            this.toastr.warning('Integrator can be invited only by administrator');
                            return [2 /*return*/];
                        }
                        this.commonService.setLoadingSpinner(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 13, , 14]);
                        userId = void 0;
                        if (!(result.roleDesc === 'INTEGRATOR')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.adminService.checkUserExist(result.email)];
                    case 3:
                        userId = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!!userId) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.adminService.addUser(result.email)];
                    case 5:
                        rsp = _a.sent();
                        userId = rsp.data[0].usr_id;
                        // Send new user a confirmation email
                        return [4 /*yield*/, this.authService.inviteUser(result.email)];
                    case 6:
                        // Send new user a confirmation email
                        _a.sent();
                        this.toastr.success('An email has been sent to the user for verification.');
                        return [3 /*break*/, 7];
                    case 7:
                        _a.trys.push([7, 11, , 12]);
                        return [4 /*yield*/, this.adminService.addUserSubscription(userId, this.userService.getUserInfo().subscriptionId, result.roleId)];
                    case 8:
                        _a.sent();
                        // Update admin // TODO
                        return [4 /*yield*/, this.adminService.updateUserAdmin(true, result.email)];
                    case 9:
                        // Update admin // TODO
                        _a.sent();
                        // Update users
                        return [4 /*yield*/, this.updateTable()];
                    case 10:
                        // Update users
                        _a.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        err_2 = _a.sent();
                        console.log(err_2);
                        this.toastr.error('Failed to add user subscription');
                        return [3 /*break*/, 12];
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        err_3 = _a.sent();
                        this.toastr.error(err_3.message);
                        return [3 /*break*/, 14];
                    case 14:
                        this.commonService.setLoadingSpinner(false);
                        _a.label = 15;
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    ConfigUsersComponent.prototype.removeUser = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var options, data, result, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Not allow deleting self
                        if (row[this.userEmailCol] === this.userService.getUserInfo().userEmail) {
                            this.toastr.info('You cannot delete yourself!');
                            return [2 /*return*/];
                        }
                        options = this.modalService.confirmModalOptions;
                        data = {
                            message: 'Are you sure you want to delete this user: ' + row[this.userEmailCol] + '?'
                        };
                        options.data = data;
                        return [4 /*yield*/, this.modalService.openModalWindow(ConfirmModalComponent, options)];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, this.adminService.deleteUser(row[this.userEmailCol])];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.updateTable()];
                    case 4:
                        _a.sent();
                        this.toastr.success('The user has been deleted successfully.');
                        return [3 /*break*/, 6];
                    case 5:
                        err_4 = _a.sent();
                        this.toastr.error('Failed to delete the user.');
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ConfigUsersComponent.prototype.search = function () {
        this.rows = this.filterRows();
    };
    ConfigUsersComponent.prototype.pickIntegrator = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            width: '550px',
                            height: '450px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(IntegratorSelectComponent, options)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigUsersComponent.prototype.updateTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userSubs, rows, newUserRow;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminService.getUserSubscription()];
                    case 1:
                        userSubs = _a.sent();
                        rows = [];
                        userSubs.forEach(function (usb) {
                            var row = {};
                            row[_this.userEmailCol] = usb.userEmail;
                            row[_this.roleCol] = usb.role;
                            row[_this.originalRoleCol] = usb.role;
                            row[_this.usbIdCol] = usb.userSubId;
                            rows.push(row);
                        });
                        newUserRow = {};
                        newUserRow[this.isNewUserCol] = true;
                        newUserRow[this.userEmailCol] = '';
                        newUserRow[this.roleCol] = this.appinfoService.rolesByApp[AppSettings.appName][0].desc;
                        newUserRow[this.originalRoleCol] = newUserRow[this.roleCol];
                        rows.push(newUserRow);
                        this.unfilteredRows = rows;
                        this.rows = this.filterRows();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Filter rows with searchStr
    ConfigUsersComponent.prototype.filterRows = function () {
        var _this = this;
        if (this.searchStr) {
            return this.unfilteredRows.filter(function (r) {
                // Always show newUserRow
                if (r[_this.isNewUserCol]) {
                    return true;
                }
                if (r[_this.userEmailCol]) {
                    return r[_this.userEmailCol].toLowerCase().indexOf(_this.searchStr.toLowerCase()) > -1;
                }
                return false;
            });
        }
        else {
            return this.unfilteredRows;
        }
    };
    // Set table columns
    ConfigUsersComponent.prototype.setColumns = function () {
        var _this = this;
        var columns = [];
        // Add user name column
        var userEmailCol = this.tableService.setNewColumn(this.userEmailCol, 'User Name', {
            skipGdoCheck: true,
            // width: 200,
            // cellTemplate: this.userEmailTempl,
            isNameKeepCase: true
        });
        columns.push(userEmailCol);
        // Add role columns
        var roles = this.appinfoService.rolesByApp[AppSettings.appName];
        roles.forEach(function (r) {
            var col = _this.tableService.setNewColumn(r.desc, null, {
                align: 'C',
                skipGdoCheck: true,
                cellTemplate: _this.roleTempl,
                isNameKeepCase: true
            });
            columns.push(col);
        });
        // Add operations column
        var operationsCol = this.tableService.setNewColumn(this.operationsCol, 'Add/Remove', {
            align: 'C',
            skipGdoCheck: true,
            cellTemplate: this.operationsTempl,
            isNameKeepCase: true
        });
        columns.push(operationsCol);
        this.columns = columns;
    };
    ConfigUsersComponent.prototype.ngOnInit = function () {
        // Tell paneControl current pane is switched to config, so that the highlighted menu item can change to config
        this.paneService.currPane.next({
            paneType: 'config',
            submenu: 'configUsers'
        });
        this.isAdmin = this.userService.getUserInfo().isAdmin;
        this.customerType = this.userService.customerInfo.type;
    };
    ConfigUsersComponent.prototype.ngAfterViewInit = function () {
        this.setColumns();
        this.updateTable();
    };
    return ConfigUsersComponent;
}());
export { ConfigUsersComponent };
